export default __webpack_public_path__ + "static/media/testimonial-2.3242bb11.webp";